import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { supplementalFormRouteMap } from '@/config/supplementalFormRouteMap'
import {
  SupplementalParent,
  useSupplementalFormStore,
} from '@/storage/supplementalForms'
import { storeToRefs } from 'pinia'
import { SupplementalFormType } from '@verifiedit/form-generator'

const supplementalFormGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const { setCurrentSupplementalForm, setRouteTo, setRouteFrom } =
    useSupplementalFormStore()
  const { routeFrom, forms } = storeToRefs(useSupplementalFormStore())

  const fromRoute = from.name === 'supplementalForm' ? routeFrom.value : from

  const routeCanHaveSupplementalForm = [
    ...supplementalFormRouteMap.values(),
  ].some((routes) => routes.includes(fromRoute?.name as string))

  if (!routeCanHaveSupplementalForm) {
    next()
    return
  }

  let supplemental: SupplementalFormType | undefined = undefined
  let parent: SupplementalParent | undefined = undefined

  for (const parentKey in forms.value) {
    const found = forms.value[parentKey].forms.find(
      (form: SupplementalFormType) =>
        supplementalFormRouteMap
          .get(form.after)
          ?.includes(fromRoute?.name as string),
    )
    if (found) {
      parent = parentKey as SupplementalParent
      supplemental = found
      break
    }
  }

  const noFormsLeft = Object.entries(forms.value).every(
    ([, value]) => value.forms.length === 0,
  )

  if (to.name === 'supplementalForm' && noFormsLeft) {
    next({ name: routeFrom.value?.name as string })
  } else if (to.name !== 'supplementalForm' && !!supplemental && !!parent) {
    setCurrentSupplementalForm(parent, supplemental)
    setRouteFrom({
      name: fromRoute?.name,
      params: fromRoute?.params,
    } as RouteLocationNormalized)
    setRouteTo({
      name: to.name as string,
      params: to.params,
    } as RouteLocationNormalized)

    next({
      name: 'supplementalForm',
    })
  } else {
    next()
  }
}

export { supplementalFormGuard }
